import React from 'react';
import { useNavigate } from 'react-router-dom';

interface GameHeaderProps {
  score: number;
  attempts: number;
  maxAttempts: number;
}

export const GameHeader: React.FC<GameHeaderProps> = ({ score, attempts, maxAttempts }) => {
  const navigate = useNavigate();

  return (
    <header className="flex justify-between items-center">
      <button
        onClick={() => navigate('/dashboard')}
        className="text-white hover:opacity-80 transition-opacity"
      >
        ← Back to Dashboard
      </button>
      <div className="flex items-center space-x-8">
        <div className="text-xl">
          Attempts: {attempts}/{maxAttempts}
        </div>
        <div className="text-2xl font-bold">Score: {score}</div>
      </div>
    </header>
  );
};